import { combineReducers } from "@reduxjs/toolkit";
import authenticationReducer from "../authentication/authentication-reducer";
import otpAuth from "../otp-auth/reducer";

const appReducer = combineReducers({
    authentication: authenticationReducer,
    otpAuth: otpAuth
});

export default appReducer;
